'use strict';

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _objectWithoutProperties = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _excluded = ["onClick", "href", "external"];
Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = require('./extends-214be52a.js');

var _styled = require('styled-components');

var React = require('react');

var index = require('./index-6b8189f0.js');

var ButtonBase = require('./ButtonBase.js');

var Theme = require('./Theme.js');

var constants = require('./constants.js');

require('./_commonjsHelpers-b3309d7b.js');

require('./FocusVisible.js');

require('./defineProperty-754b29ce.js');

require('./keycodes.js');

require('./css.js');

require('./text-styles.js');

require('./font.js');

require('./environment.js');

require('./miscellaneous.js');

require('./theme-dark.js');

require('./theme-light.js');

require('./color.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var _styled__default = /*#__PURE__*/_interopDefaultLegacy(_styled);

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function Link(_ref) {
  var _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? undefined : _ref$href,
      _ref$external = _ref.external,
      external = _ref$external === void 0 ? undefined : _ref$external,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = Theme.useTheme(); // `external` defaults to `true` if `href` is present, `false` otherwise.

  if (external === undefined) {
    external = Boolean(href);
  }

  return /*#__PURE__*/React__default["default"].createElement(_StyledButtonBase, _extends._extends({
    href: href,
    onClick: onClick,
    external: external,
    focusRingSpacing: [6, 2],
    focusRingRadius: constants.RADIUS
  }, props, {
    $_css: theme.link,
    $_css2: external ? 'underline' : 'none'
  }));
}

Link.propTypes = _objectSpread(_objectSpread({}, ButtonBase["default"].propTypes), {}, {
  href: index.PropTypes.string,
  onClick: index.PropTypes.func,
  external: index.PropTypes.bool
});

var _StyledButtonBase = _styled__default["default"](ButtonBase["default"]).withConfig({
  displayName: "Link___StyledButtonBase",
  componentId: "sc-1eme5g-0"
})(["color:", ";text-decoration:", ";font-size:inherit;"], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
});

exports["default"] = Link;